import React from "react";
import { Link } from "react-router-dom";

const SuccessPage = () => {
    return (
        <div className="success-page-main">
            <h1 className="title-blue">Payment Successful!</h1>
            <img src="/mainImages/icons/success.png" alt="success" className="success-icon" />
            <p>Thank you for your purchase. Your order is being processed.</p>
            <p> You will receive a pin code in your email shortly. </p>
            {/* <p> If you have purchased a VR version of the course, you will receive the download link in your email</p> */}
            <Link to="/gameplay" className="blue-text">
                {/* For PC-based games  */}
                Click here Go to Game Play Page
            </Link>

        </div>
    );
};

export default SuccessPage;